// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host-context(.active) .wrap p {
  text-shadow: 0px 0px 1px #4c4c4c;
}
:host-context(.active) .wrap .progress {
  background: #9a9ab0;
  box-shadow: 0px 0px 1px 0.5px rgba(0, 0, 0, 0.37);
}

.wrap {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: flex-start;
  justify-content: center;
  background: inherit;
  transition: all 0.2s;
  cursor: pointer;
  box-sizing: border-box;
}
.wrap:hover p {
  text-shadow: 0px 0px 1px #4c4c4c;
}
.wrap:hover .progress {
  box-shadow: 0px 0px 1px 0.5px rgba(0, 0, 0, 0.37);
}
.wrap.active {
  background: #e2e1f9;
}
.wrap.disabled {
  opacity: 0.3;
  background: inherit;
  cursor: not-allowed;
}

p {
  min-width: 14px;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  color: var(--grey);
  transition: all 0.2s;
}

.progress {
  position: relative;
  width: 100%;
  height: 8px;
  border-radius: 30px;
  background: var(--bg-progress-color);
  transition: all 0.2s;
}

.filled {
  background: var(--unfill-progress-color);
}

.filled-text {
  color: #4c4c4c;
}

.progress-fill {
  position: absolute;
  border-radius: 30px;
  left: 0;
  top: 0;
  height: 100%;
  background: var(--fill-progress-color);
}`, "",{"version":3,"sources":["webpack://./src/shared/progress-bar/components/progress-item/progress-item.component.scss"],"names":[],"mappings":"AAEI;EACE,gCAAA;AADN;AAII;EACE,mBAAA;EACA,iDAAA;AAFN;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,sBAAA;AAJF;AAOI;EACE,gCAAA;AALN;AAQI;EACE,iDAAA;AANN;AAUE;EACE,mBAAA;AARJ;AAWE;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;AATJ;;AAaA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AAVF;;AAaA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,oCAAA;EACA,oBAAA;AAVF;;AAaA;EACE,wCAAA;AAVF;;AAaA;EACE,cAAA;AAVF;;AAaA;EACE,kBAAA;EACA,mBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,sCAAA;AAVF","sourcesContent":[":host-context(.active) {\n  .wrap {\n    p {\n      text-shadow: 0px 0px 1px #4c4c4c;\n    }\n\n    .progress {\n      background: #9a9ab0;\n      box-shadow: 0px 0px 1px 0.5px rgba(0, 0, 0, 0.37);\n    }\n  }\n}\n\n.wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  align-items: flex-start;\n  justify-content: center;\n  background: inherit;\n  transition: all 0.2s;\n  cursor: pointer;\n  box-sizing: border-box;\n\n  &:hover {\n    p {\n      text-shadow: 0px 0px 1px #4c4c4c;\n    }\n\n    .progress {\n      box-shadow: 0px 0px 1px 0.5px rgba(0, 0, 0, 0.37);\n    }\n  }\n\n  &.active {\n    background: #e2e1f9;\n  }\n\n  &.disabled {\n    opacity: 0.3;\n    background: inherit;\n    cursor: not-allowed;\n  }\n}\n\np {\n  min-width: 14px;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14px;\n  letter-spacing: 0em;\n  color: var(--grey);\n  transition: all 0.2s;\n}\n\n.progress {\n  position: relative;\n  width: 100%;\n  height: 8px;\n  border-radius: 30px;\n  background: var(--bg-progress-color);\n  transition: all 0.2s;\n}\n\n.filled {\n  background: var(--unfill-progress-color);\n}\n\n.filled-text {\n  color: #4c4c4c;\n}\n\n.progress-fill {\n  position: absolute;\n  border-radius: 30px;\n  left: 0;\n  top: 0;\n  height: 100%;\n  background: var(--fill-progress-color);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
